<script setup>

import BenchmarkItem from "@/components/Benchmark/BenchmarkItem.vue";

import { ref, onMounted } from 'vue'


const data = ref(null)

//get http /api/v3/benchmark
const getBenchmark = async () => {
  const response = await fetch('/api/v3/benchmark')
  data.value =  await response.json()
}


//on mount
onMounted(() => {
  getBenchmark()
})

</script>

<template>
  <div class="p-10">
    <h1 class="text-2xl">Performance</h1>


        <BenchmarkItem v-for="item in data" :benchmark="item" :parent-duration="0">
        </BenchmarkItem>

  </div>
</template>

<style scoped>

</style>